import { render, staticRenderFns } from "./reportQuestionDetail_item.vue?vue&type=template&id=14c69624&scoped=true"
import script from "./reportQuestionDetail_item.vue?vue&type=script&lang=js"
export * from "./reportQuestionDetail_item.vue?vue&type=script&lang=js"
import style0 from "./reportQuestionDetail_item.vue?vue&type=style&index=0&id=14c69624&scoped=true&lang=scss"
import style1 from "./reportQuestionDetail_item.vue?vue&type=style&index=1&id=14c69624&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c69624",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c69624')) {
      api.createRecord('14c69624', component.options)
    } else {
      api.reload('14c69624', component.options)
    }
    module.hot.accept("./reportQuestionDetail_item.vue?vue&type=template&id=14c69624&scoped=true", function () {
      api.rerender('14c69624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/reportQuestionDetail_item.vue"
export default component.exports